import { createContext } from 'react';
import BuildModalScreen from '../../types/BuildModalScreen';
import LiveBotVersion from '../../types/LiveBotVersion';

interface BotStatusContextProps {
  isLoading: boolean;
  error: string | null;
  liveBotVersion: LiveBotVersion | null;
  getChatbotStatus: () => void;
  isDraftVersion: boolean;
  buildChatbot: () => void;
  currentScreen: BuildModalScreen;
  progress: number;
  resetBuildState: () => void;
  setError: (error: string | null) => void;
}

const BotStatusContext = createContext<BotStatusContextProps>({
  isLoading: false,
  error: null,
  liveBotVersion: null,
  getChatbotStatus: () => {},
  isDraftVersion: false,
  buildChatbot: () => {},
  currentScreen: 'build',
  progress: 0,
  resetBuildState: () => {},
  setError: () => {}
});

export default BotStatusContext;
